import { render, staticRenderFns } from "./Noticeboard.vue?vue&type=template&id=1c7ff6a9&"
import script from "./Noticeboard.vue?vue&type=script&lang=ts&"
export * from "./Noticeboard.vue?vue&type=script&lang=ts&"
import style0 from "./Noticeboard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Noticeboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports